import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";

interface CenteredLoaderProps {
  animationPath?: string;
  size?: number;
}

const CenteredLoader: React.FC<CenteredLoaderProps> = ({
  animationPath = "/animation/loading_animation.json", // Public URL
  size = 400,
}) => {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    fetch(animationPath)
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((error) => console.error("Error loading Lottie animation:", error));
  }, [animationPath]);

  if (!animationData) {
    return <div>Loading...</div>; // Show a fallback while loading
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100%",
      }}
    >
      <Lottie animationData={animationData} style={{ width: size, height: size }} />
    </div>
  );
};

export default CenteredLoader;
